export default "__VITE_ASSET__DwV_kUng__"